import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Jobs } from '../../models/jobs.model';
import { FunctionsService } from '../../services/functions.service';
import Swal from 'sweetalert2';
import { HttpService } from '../../services/http.service';
import { UsersService } from '../../services/users.service';
import { Candidates } from '../../models/candidates.model';
import { formatDate } from '@angular/common';
import { Companies } from '../../models/companies.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-job-card',
  templateUrl: './job-card.component.html',
  styleUrls: ['./job-card.component.scss']
})
export class JobCardComponent implements OnInit {
  baseURL = environment.apiUrl;

  @Input() jobList!: Jobs[];
  @Input() typeInterface: string = 'candidat';
  candidates: Candidates;
  currentCompany: any;
  currentAdmin: any;
  typeUser: any;

  constructor(private httpService: HttpService, private usersService: UsersService, public functionsService: FunctionsService, private router: Router) {
    this.candidates = this.usersService.getCurrentUser();
    this.currentCompany = this.usersService.getCurrentUser();
    this.currentAdmin = functionsService.checkAdminIsConnected();
    this.typeUser = this.usersService.getUserType();
  }

  ngOnInit(): void {
  }

  jobIsExpired(jobExpiredDate: any) {
    const currentDate = new Date();
    const jobDate = new Date(this.reformatStringDate(jobExpiredDate));

    if (currentDate < jobDate) {
      return false;
    }

    return true;
  }

  reformatStringDate(stringDate: string) {
    const splitResult = stringDate.split('-');

    return splitResult[2] + '-' + splitResult[1] + '-' + splitResult[0];
  }

  getCandidatesApplyJob(job: Jobs) {
    if (job.getId() != undefined) {
      localStorage.setItem('job', JSON.stringify(job));
      this.router.navigate(['/candidats-offre', job.getId()]);
    }
  }

  deleteJob(job: Jobs) {
    let formValue: any = [];

    formValue['job_id'] = job.getId();
    formValue['token'] = (this.currentAdmin) ? this.currentAdmin['token'] : ((this.currentCompany) ? this.currentCompany.getToken() : null);

    Swal.fire({
      title: 'Souhaitez vous supprimer cette offre d\'emploi ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.deleteJob(formValue).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              Swal.fire({
                icon: 'success',
                title: 'Excellent!',
                text: 'Emploi supprimé avec succès.',
              }).then(() => {
                location.reload();
              });
            }
          },
          (error) => {
            if (error.error.message && error.error.message == 'TOKEN_INCORRECT') {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Une erreur est survenue pendant l\'opération. Déconnectez vous, reconnectez vous, puis réessayé.',
              })
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Vérifier votre connexion puis réessayée.',
              })
            }
          }
        );
      }
    });
  }

  editJob(job: Jobs) {
    if (job.getId() != undefined) {
      localStorage.setItem('jobEditing', JSON.stringify(job));
      (this.typeInterface == 'admin') ? this.router.navigate(['/admin/publier-offre-emploi']) : this.router.navigate(['/publier-offre-emploi']);
    }
  }

  addJobInBackup(jobID: number) {
    (this.candidates == undefined) ? this.router.navigate(['/connexion']) : this.candidates;

    const backupJobList: Jobs[] = this.candidates.getCandidatesSaveJobs();

    if (backupJobList.length == 0) {
      const jobToAdd: Jobs = this.searchJobByID(jobID);
      (jobToAdd != null) ? this.saveJob(jobID) : false;
    } else {
      if (this.checkJobInBackupList(jobID, backupJobList)) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Cette offre d\'emploi existe déjà dans vos sauvegardes.',
        })
      } else {
        const jobToAdd: Jobs = this.searchJobByID(jobID);
        (jobToAdd != null) ? this.saveJob(jobID) : false;
      }
    }
  }
  saveJob(jobID: number) {
    Swal.fire('Veuillez patientez...');
    this.httpService.saveBackupJob(jobID, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));

          Swal.fire({
            icon: 'success',
            title: 'Excellent!',
            text: 'Offre d\'emploi ajoutée à vos sauvegades',
          })
        }
      },
      (error) => {
        if (error.error.message == 'JOB_ALREADY_SAVE_WITH_THIS_CANDIDATE') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Cette offre existe déjà dans vos sauvegardes.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  checkJobInBackupList(jobID: number, backupList: Jobs[]): boolean {
    let result = false;
    backupList.forEach((element) => {
      const job = new Jobs(element);
      if (job.getId() == jobID) {
        result = true;
      }
    });

    return result;
  }

  searchJobByID(jobID: number): any {
    let jobFind;
    this.jobList.forEach((job: Jobs) => {
      if (job.getId() == jobID) {
        jobFind = job;
      }
    });

    return jobFind;
  }

}
